"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var socialAuthApi_1 = __importDefault(require("../../api/socialAuthApi"));
var path_1 = require("../../definition/path");
var lineAuth_1 = require("../../util/lineAuth");
var LineCallback_module_scss_1 = __importDefault(require("./LineCallback.module.scss"));
var LineCallback = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var _a = (0, react_1.useState)(""), errorMessage = _a[0], setErrorMessage = _a[1];
    var hasHandledRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (hasHandledRef.current) {
            return;
        }
        hasHandledRef.current = true;
        var code = searchParams.get("code") || "";
        var state = searchParams.get("state") || "";
        var error = searchParams.get("error") || "";
        var expectedState = window.sessionStorage.getItem(lineAuth_1.LINE_STATE_STORAGE_KEY);
        window.sessionStorage.removeItem(lineAuth_1.LINE_STATE_STORAGE_KEY);
        window.sessionStorage.removeItem(lineAuth_1.LINE_NONCE_STORAGE_KEY);
        if (error) {
            setErrorMessage(searchParams.get("error_description") ||
                t("LINE_AUTH_ERROR_LOGIN_FAILED"));
            return;
        }
        if (!code) {
            setErrorMessage(t("LINE_AUTH_ERROR_MISSING_CODE"));
            return;
        }
        if (!expectedState || expectedState !== state) {
            setErrorMessage(t("LINE_AUTH_ERROR_STATE_MISMATCH"));
            return;
        }
        var verifyLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
            var verifiedLogin, verifyError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, socialAuthApi_1.default.startLineOAuthLogin({
                                code: code,
                                redirect_uri: (0, lineAuth_1.buildLineRedirectUri)()
                            })];
                    case 1:
                        verifiedLogin = _a.sent();
                        window.sessionStorage.setItem("pos.socialAuth.lineUser", JSON.stringify(verifiedLogin.user));
                        window.sessionStorage.setItem("pos.socialAuth.accessToken", verifiedLogin.access_token || verifiedLogin.session_id);
                        navigate(path_1.Page.OfferPage, { replace: true });
                        return [3 /*break*/, 3];
                    case 2:
                        verifyError_1 = _a.sent();
                        setErrorMessage(verifyError_1 instanceof Error
                            ? verifyError_1.message
                            : t("LINE_AUTH_ERROR_LOGIN_FAILED"));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        void verifyLogin();
    }, [navigate, searchParams, t]);
    return ((0, jsx_runtime_1.jsx)("main", { className: LineCallback_module_scss_1.default.callbackPage, children: (0, jsx_runtime_1.jsxs)("section", { className: LineCallback_module_scss_1.default.callbackCard, children: [(0, jsx_runtime_1.jsx)("h1", { className: LineCallback_module_scss_1.default.callbackTitle, children: t("LINE_AUTH_CALLBACK_TITLE") }), errorMessage ? ((0, jsx_runtime_1.jsx)("p", { className: LineCallback_module_scss_1.default.callbackError, children: errorMessage })) : ((0, jsx_runtime_1.jsx)("p", { className: LineCallback_module_scss_1.default.callbackText, children: t("LINE_AUTH_CALLBACK_TEXT") }))] }) }));
};
exports.default = (0, react_i18next_1.withTranslation)()(LineCallback);
